'use client';

import { useQueryState } from 'nuqs';

export function useHasWastageState() {
  const [hasWastage, setHasWastage] = useQueryState('has_wastage', {
    defaultValue: true,
    parse: (value) => value === 'true',
    serialize: (value) => (value ? 'true' : 'false'),
  });

  return {
    hasWastage,
    setHasWastage,
  };
}
